<div
  class="filter-dropdown"
  [class.filter-dropdown--open]="isDropdownOpen"
  [class.filter-dropdown--has-value]="hasValue"
>
  <button
    class="filter-dropdown__button"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="toggleDropdown()"
  >
    <span class="filter-dropdown__button-text">
      <ng-container *ngTemplateOutlet="dropdownButtonTemplate"></ng-container>
    </span>

    <ng-container *ngIf="hasValue; else defaultIcon">
      <button class="filter-dropdown__reset-button" (click)="onReset($event)">
        <i
          class="material-icon filter-dropdown__reset-icon material-icon--filled"
        >
          close
        </i>
      </button>
    </ng-container>

    <ng-template #defaultIcon>
      <i
        class="filter-dropdown__button-arrow material-icon material-icon--filled"
      >
        arrow_drop_down
      </i>
    </ng-template>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOpen]="isDropdownOpen"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayGrowAfterOpen]="true"
    [cdkConnectedOverlayLockPosition]="true"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayViewportMargin]="16"
    (overlayOutsideClick)="close()"
    (detach)="close()"
  >
    <div
      class="filter-dropdown__dropdown"
      [class.filter-dropdown__dropdown--scrollable]="isScrollable"
      [style.minWidth]="dropdownMinWidth"
      [style.maxHeight]="dropdownMaxHeight"
      cdkScrollable
      cdkTrapFocus
      [cdkTrapFocusAutoCapture]="true"
    >
      <div class="filter-dropdown__main" #scrollContainer>
        <ng-container
          *ngTemplateOutlet="dropdownContentTemplate"
        ></ng-container>
      </div>

      <div class="filter-dropdown__apply-button">
        <ng-container
          *ngTemplateOutlet="applyButtonTemplate; context: templateContext"
        ></ng-container>
      </div>
    </div>
  </ng-template>
</div>
